module.exports = __webpack_public_path__ + "static/stay-compliant-6349cc230da63b3bfc86cfbdc4b1dbbe.png";